import { companyProfile } from "../data/siteContent";

export const buildMailtoUrl = ({ name, company, email, message }) => {
  const subject = `Inquiry from ${name}`;
  const bodyLines = [
    `Name: ${name}`,
    `Company: ${company || "N/A"}`,
    `Email: ${email}`,
    "",
    message,
  ];

  const subjectParam = encodeURIComponent(subject);
  const bodyParam = encodeURIComponent(bodyLines.join("\n"));

  return `mailto:${companyProfile.contactEmail}?subject=${subjectParam}&body=${bodyParam}`;
};